import { Small } from "@/components/standard/BFText"
import { Horizontal } from "@/components/standard/BFLayout"
import WarningDiamond from "phosphor-react-native/src/icons/WarningDiamond"
import { cn } from "@/lib/utils"

export const NegativeROIWarning = ({ show = false }: { show?: boolean }) => {
  return (
    <Horizontal
      className={cn(
        show ? "" : "opacity-0",
        "bg-red-orange gap-2 items-center text-white p-4 text-center rounded-md my-2"
      )}
    >
      <WarningDiamond color={"white"} size={22} />
      <Small color={"white"}>Your gross profit potential is negative</Small>
    </Horizontal>
  )
}
